import React from 'react';
function isErrorWithCause(error) {
    return (error === null || error === void 0 ? void 0 : error.cause) && typeof error.cause === 'object';
}
var DefaultErrorComponent = function (_a) {
    var error = _a.error, errorInfo = _a.errorInfo;
    if (isErrorWithCause(error)) {
        return React.createElement(DefaultErrorComponent, { error: error.cause, errorInfo: errorInfo });
    }
    return (React.createElement("div", null,
        React.createElement("h2", null, "Error loading component"),
        typeof error === 'string' && React.createElement("p", null, error),
        (error === null || error === void 0 ? void 0 : error.cause) && typeof (error === null || error === void 0 ? void 0 : error.cause) !== 'object' && React.createElement("p", null, error.cause),
        (error === null || error === void 0 ? void 0 : error.message) && React.createElement("p", null, error.message),
        (errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.componentStack) ? React.createElement("pre", null, errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.componentStack) : (error === null || error === void 0 ? void 0 : error.stack) && React.createElement("pre", null, error.stack)));
};
export default DefaultErrorComponent;
//# sourceMappingURL=default-error-component.js.map